import {useMemo} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import messages from "./messages";
import {Grid, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Base from "components/Message/Base";
import {withRouter} from "react-router";
import clsx from "clsx";
import moment from "moment";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  poDetails: {
    borderBottom: "1px solid rgba(0,0,0,0.46)",
    paddingBottom: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(2, 0),
    textAlign: "center",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTop: "1px solid rgba(0,0,0,0.46)",
    padding: theme.spacing(2),
  },
  marginTop: {
    marginTop: theme.spacing(2),
  },
  marginSides: {
    margin: theme.spacing(0, 2),
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
    borderRadius: "15px",
    border: "1px solid black",
    maxWidth: "300px",
    lineHeight: 1,
  },
  messageBox: {
    borderLeft: "none",
    border: "1px solid rgba(0,0,0,0.24)",
    borderColor: "rgba(0,0,0,0.24)",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center",
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  infoContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&.old": {
      color: "#e68058",
    },
  },
}));

function TreatmentDeleted({ activeMessage = {}, onClose, showPatient }) {
  const classes = useStyles();

  const body = useMemo(
    () => (
      <div className={classes.body}>
        <div className={clsx(classes.poDetails, {
          active: true
        })}>
          <FormattedMessage
            {...messages.appointment_deleted_title}
          />
          <div className={clsx(classes.infoContainer, {
            old: true
          })}>
            <div className={classes.textContainer}>
              <Typography variant="caption">
                <FormattedMessage {...messages.planned_treatment_date} />
              </Typography>
              <Typography>
                {moment(
                  activeMessage.planned_date_time_from || activeMessage.plannedTreatment.planned_date_time_from,
                ).format("DD-MM-YYYY")}
              </Typography>
            </div>
            <div className={classes.textContainer}>
              <Typography variant="caption">
                <FormattedMessage {...messages.planned_treatment_time} />
              </Typography>
              <Typography>
                {moment(
                  activeMessage.planned_date_time_from || activeMessage.plannedTreatment.planned_date_time_from,
                ).format("HH.mmu")}{" "}
                -{" "}
                {moment(
                  activeMessage.planned_date_time_to || activeMessage.plannedTreatment.planned_date_time_to,
                ).format("HH.mmu")}
              </Typography>
            </div>
            {(activeMessage.bumbalDriver || activeMessage.plannedTreatment.bumbalDriver) && (
              <div className={classes.textContainer}>
                <Typography variant="caption">
                  <FormattedMessage {...messages.planned_treatment_kpt} />
                </Typography>
                <Typography>
                  {activeMessage.bumbalDriver?.first_name || activeMessage.plannedTreatment.bumbalDriver.first_name}
                </Typography>
              </div>
            )}
          </div>
        </div>
        <Grid container className={classes.content}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="caption">
              <FormattedMessage {...messages.order_placed_upper_product} />
            </Typography>
            <Typography variant="subtitle1">
              {activeMessage.plannedTreatment.upperProductName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="caption">
              <FormattedMessage {...messages.order_placed_lower_product} />
            </Typography>
            <Typography variant="subtitle1">
              {activeMessage.plannedTreatment.lowerProductName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="caption">
              <FormattedMessage {...messages.order_placed_phase} />
            </Typography>
            <Typography variant="subtitle1">
              {activeMessage.plannedTreatment.treatmentName}
            </Typography>
          </Grid>
        </Grid>
      </div>
    ),
    [
      classes.body,
      classes.poDetails,
      classes.content,
      classes.textContainer,
      classes.infoContainer,
      activeMessage.plannedTreatment.upperProductName,
      activeMessage.plannedTreatment.lowerProductName,
      activeMessage.plannedTreatment.treatmentName,
      activeMessage.plannedTreatment.planned_date_time_from,
      activeMessage.plannedTreatment.planned_date_time_to,
    ],
  );

  return (
    <Base
      onClose={onClose}
      activeMessage={activeMessage}
      shouldRenderPatient={showPatient}
      title={<FormattedMessage {...messages.appointment_deleted_title} />}
    >
      {body}
    </Base>
  );
}

TreatmentDeleted.propTypes = {
  activeMessage: PropTypes.shape({
    updatedAt: PropTypes.number,
    plannedTreatment: PropTypes.shape({
      lowerProductName: PropTypes.string,
      upperProductName: PropTypes.string,
      treatmentName: PropTypes.string,
      avadentCaseId: PropTypes.string,
      deliveryDate: PropTypes.number,
      planned_date_time_from: PropTypes.string,
    }),
    treatmentPlan: PropTypes.shape({
      caseId: PropTypes.string,
    }),
    patient: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  onClose: PropTypes.func.isRequired,
};

export default withRouter(TreatmentDeleted);
